export enum ServiceGroupType {
	EMoney = 1,
	Crypto = 2
}